<template>
  <div class="componentsCtn_1">
    <div class="top">
      我的矢量

    </div>
    <div class="searchAddCtn">
      <a-input v-model="searchName" size="large" style="height: 40px;width:600px;font-size: 14px;float:left;" placeholder="请输入矢量名称">
        <a-tooltip @click="searchVectorByName" title="点击搜索" slot="suffix" style="cursor:pointer;">
          <a-icon type="search" style="color: rgba(0,0,0,.45); fontSize: 18px"/>
        </a-tooltip>
      </a-input>
      <div class="addVectorButton" title="添加矢量" @click="createVector">
        <img src="../../assets/userCenter/新增矢量.png" height="21" width="21"/>
      </div>
    </div>

    <div class="tableCtn">
      <a-table :columns="tableColumns" :data-source="tableData" :pagination="ipagination"
      @change="handleTableChange">

             <span slot="action" slot-scope="text, record">
                  <a  @click="clickOverview(record)">查看</a>
                  <a-divider type="vertical"/>
                  <a @click="clickDownloadVector(record)">下载</a>
                  <a-divider type="vertical"/>
                  <a @click="clickDeleteVector(record)" v-if="record.useintiles==0">删除</a>
                  <a v-if="record.useintiles==1" style="color:#CCCCCC">删除</a>
                </span>
      </a-table>
    </div>
    <!--删除矢量对话框-->
    <a-modal v-model="deleteVectorModal"
             centered
             width="590"
             title="矢量删除确认"
    >
      <div style="width:590px;height:70px;margin-top: 20px;padding-left: 60px;">
        <div style="float:left;width:63px;height: 63px;">
          <img src="../../assets/userCenter/我的项目-注意.png" height="63" width="63"/>
        </div>
        <div
            style="float:left;width: calc(100% - 63px);height:63px;line-height: 31px;padding-left: 20px;font-size:20px;">
          确定删除矢量：{{deleteVectorName}} ？ <br/>
          此操作无法撤回，请您务必知悉。
        </div>
      </div>
      <template slot="footer">
        <a-button @click="confirmDeleteVector()" type="primary">
          确定
        </a-button>
        <a-button @click="deleteVectorModal=false">
          取消
        </a-button>
      </template>
    </a-modal>
    <!--删除矢量对话框-->
    <a-modal v-model="deleteVectorModal"
             centered
             width="590"
             title="矢量删除确认"
    >
      <div style="width:590px;height:70px;margin-top: 20px;padding-left: 60px;">
        <div style="float:left;width:63px;height: 63px;">
          <img src="../../assets/userCenter/我的项目-注意.png" height="63" width="63"/>
        </div>
        <div
            style="float:left;width: calc(100% - 63px);height:63px;line-height: 31px;padding-left: 20px;font-size:20px;">
          确定删除矢量：{{deleteVectorName}} ？ <br/>
          此操作无法撤回，请您务必知悉。
        </div>
      </div>
      <template slot="footer">
        <a-button @click="confirmDeleteVector()" type="primary">
          确定
        </a-button>
        <a-button @click="deleteVectorModal=false">
          取消
        </a-button>
      </template>
    </a-modal>
    <!--创建矢量对话框-->
    <a-modal v-model="createVectorModal"
             centered width="1330px" :header="null"
             :footer="null"
    >
      <div class="createVectorTitle">
        <span style="float:left">创建新矢量</span>
        <div style="width: 500px;height: 40px;line-height: 40px;font-size: 14px;color: #979797;float:left;margin-left:400px;">
          当前时间：{{nowTime}}
        </div>
      </div>
      <div class="createVectorDiv">
        <l-map
                    :maxBounds="maxBounds"
                    :minZoom="parseInt(2)"
                    ref="map"
                    style="width: 100%; height: 100%;"
                    :zoom="zoom"
                    :center="center"
                    :options="option"
                    :class="$store.state.search.targetSelecting ? 'leaflet-crosshair': ''"
            >
                <template mark="map">
                    <l-tile-layer ref="mapLayer" :url="$store.state.map.mapUrl" :options="$store.state.map.mapSubdomains" />
                    <l-tile-layer ref="infoLayer" v-show="!!$store.state.map.infoUrl" :url="$store.state.map.infoUrl"  :options="$store.state.map.mapSubdomains" />
                </template>
                 <l-geo-json
                        v-if="bufferGeo.geojson"
                        :geojson="bufferGeo.geojson"
                        :optionsStyle="bufferGeojsonStyle"
                ></l-geo-json>

                <l-geo-json
                        v-if="$store.state.search.selectedRangeStore[$store.state.search.targetType] !== ''&& !targetMode"
                        :geojson="$store.state.search.selectedRangeStore[$store.state.search.targetType]"
                        :optionsStyle="targetGeojsonStyle"
                ></l-geo-json>

               

            </l-map>
        <div>
          <img src="~@/assets/Search/draw.png" style="cursor: pointer;position: absolute; top:85px; z-index: 9999;width: 30px;height: 30px;background: linear-gradient(225deg, #225485 0%, #3277BC 100%);" @click="toggleSearchRangeSelector">
          <SearchRangeSelector v-show="showSearchRangeSelector" ref="rangeSelector" style="position: absolute; top:115px;left: 24px; z-index: 9999;" />
        </div>
        
        <!-- <pl-lazy v-if="createVectorModal">
              <main-map
              ref="mainmap"
              :lyrdata="lyrdata"
              :mapCtrlTools="mapCtrlTools4Use"
              :mapParams="mapParams"
              :showTools="false"
              >
              </main-map>
          </pl-lazy> -->
      </div>
      <div class="createVectorTitle" style="height:50px;margin-top:10px;">
        <div style="width: 1170px;height: 50px;float:left;">
          <a-input v-model="createSearchName" size="large" style="height: 50px;width:1170px;font-size: 14px;float:left;" placeholder="请输入矢量名称">

          </a-input>
        </div>
        <div v-if="createSearchName && $store.state.search.selectedRangeStore[$store.state.search.targetType]" class="createVectorButton" @click="createVectorSubmit">创建</div>
        <div v-else class="createVectorButton_grey">创建</div>
      </div>

    </a-modal>
    <!--查看矢量对话框-->
    <span class="customSet">
      <a-modal v-model="overviewVectorModal"
               centered width="660px" :header="null"
               :footer="null"
      >
        <div class="overviewVectorDiv" style="margin-left: -24px;margin-top: -24px;">
          <pl-lazy v-if="overviewVectorModal">
              <main-map
              ref="mainmap"
              :lyrdata="lyrdata"
              :mapCtrlTools="mapCtrlTools4Use"
              :mapParams="mapParams"
              :showTools="false"
              >
              </main-map>
          </pl-lazy>
        </div>
        <div v-if="overviewVectorModal" style="width: 100%;height:90px;margin-bottom: -25px;">
          <div style="height:45px;line-height: 45px;color: #3A3A3A;font-weight: bold">
            {{ vectorInfo.name }}
          </div>
          <div style="height:45px;line-height: 30px;color: #3A3A3A;">
            创建于{{ vectorInfo.create_time }}
            <div :title="vectorInfo.repository.join(',')" style="height:45px;line-height: 45px;width:200px;float:right;color: #3A3A3A;text-overflow: ellipsis;overflow: hidden;word-break: break-all;white-space: nowrap;">
              <span v-if="vectorInfo.repository.join(',')">已关联</span> {{ vectorInfo.repository.join(',') }}
              <!-- 已关联 2022年度全国高质量一张图5,2022年度全国高质量一张图6 -->
            </div>
          </div>
        </div>
      </a-modal>
    </span>
    <v-overlay :value="overlay">
      <span>正在处理，请稍后</span>
      <v-progress-circular indeterminate size="32"></v-progress-circular>
    </v-overlay>
    <v-snackbar v-model="snackbar" :color=snackbarColor :timeout="timeout" bottom>
        {{snackbarInfo}}
        <v-btn dark text @click="snackbar = false" class="text-capitalize">
            {{$vuetify.lang.t('$vuetify.demand.close')}}</v-btn>
    </v-snackbar>
  </div>


</template>

<script>
import handle from "ant-design-vue/lib/vc-slider/src/Handle";
import MainMap from '@/components/Maps/MainMap'
import SearchRangeSelector from '@/components/Maps/SearchVector/SearchRangeSelector'
import L from 'leaflet'
import { LMap,LMarker,LTileLayer,LGeoJson,LWMSTileLayer} from 'vue2-leaflet'
import 'leaflet-mouse-position'
import point from 'turf-point'
import booleanContains from '@turf/boolean-contains'
import WKT from "terraformer-wkt-parser"
import { Vector,Tile } from 'ol/layer';
import { XYZ } from 'ol/source'
import { Polygon, LineString, MultiPolygon,MultiLineString,Point } from 'ol/geom'
import Feature from 'ol/Feature';

export default {
  name: "myVectorLibrary",
  provide(){
      return{
          Search:this// 允许一个祖先组件向其所有子孙后代注入一个依赖，不论组件层次有多深，并在起上下游关系成立的时间里始终生效。
      }
  },
  components: {
    MainMap,
    SearchRangeSelector,

    LMap,
    LTileLayer,
    LGeoJson,
  },
  computed: {
    handle() {
      return handle
    }
  },
  data(){
    return{
      //搜索相关
      searchName:'',
      tableColumns:[
        {
          title:'矢量名称',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '创建时间',
          dataIndex: 'create_time',
          key: 'create_time',
          sorter:(a,b)=>a-b,

        },
        {
          title: '操作',
          key: 'action',
          scopedSlots: { customRender: 'action' },

        },
      ],
      tableData:[

      ],
      /* 分页参数 */
      ipagination:{
        current: 1,
        pageSize: 10,
        pageSizeOptions: ['10', '20', '50'],
        showTotal: (total, range) => {
          return range[0] + "-" + range[1] + " 共" + total + "条"
        },
        // showQuickJumper: true,
        // showSizeChanger: true,
        total: 0,
      },
      tableOrderType:'',
      //删除矢量相关
      deleteVectorModal:false,
      deleteVectorId:'',
      deleteVectorName:'',
      //创建矢量
      createVectorModal:false,
      createSearchName:'',
      //查看矢量
      overviewVectorModal: false,


      // openlayers参数
      lyrdata: [
        {
            lyrType:"Tile",
            srcType:"XYZ",
            // mUrl:"https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
            mUrl:"https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=a1acdff888c05743e3603302c3f64a6d",
            mTitle:"路网",
            mName:"路网",
            mVisible:true
        },
        {
            lyrType: "Tile",
            srcType: "XYZ",
            mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
            mTitle: "文字标注",
            mName: "文字标注",
            mVisible: true
        }
      ],
      mapCtrlTools4Use: [],
      mapParams: {
          projection:'EPSG:3857', //注意：必须加上此投影才能显示地图，目前有效的是4326和3857，而4490暂未生效
          center:[108.29883, 35.72902], //地图初始化时的中心坐标【基于4326坐标系】
          // center:[142.85524, 43.61710], //地图初始化时的中心坐标【基于4326坐标系】
          // mExtent:[120.45536,35.55856,139.36943,44.78707], //左下点-右上点
          minZoom:1, //可以缩小的最小级别；若此处未定义，地图接收到undefined则表示不受限制
          maxZoom:18, //可以放大的最大级别；若此处未定义，地图接收到undefined则表示不受限制
          zoom:4, //地图初始化时显示级别；注意：若此处未定义，地图初始化显示不出来
      },
      vectorInfo: {},//矢量信息
      nowTime: '',//现在时间

      // leaflet参数
      targetModePoint: L.latLng(380, 90),
      targetMode: false,
      zoom: 4,
      center: L.latLng(33.978292, 105.395057),
      maxBounds: L.latLngBounds([[85,-180], [-85,180]]),
      url: this.$store.state.mapUrl,
      subdomains: this.$store.state.mapSubdomains,
      option: { zoomControl: false, attributionControl: false, renderer: L.canvas() },
      showSearchRangeSelector: false,

      targetGeojsonStyle: {
          color: '#00BCD4',
          weight: 2,
          fillOpacity: 0
      },
      bufferGeojsonStyle: {
          color: '#F44336',
          fillColor: '#F44336',
          weight: 2,
          fillOpacity: 0.1
      },
      bufferGeo: {
        geojson: '',
        area:''
      },

      //提示相关参数
      snackbar:false,
      snackbarColor:"",
      snackbarInfo:"",
      timeout: 3000,

      overlay: false,

    }
  },
  methods: {

    clearAll() {
        this.$store.state.search.longitude = ''
        this.$store.state.search.latitude = ''
        this.$store.state.search.selectedRangeStore = {
            upload:'',
            china:'',
            world:'',
            point:'',
            draw:'',
            coordinatesArray:'',
            rectangle:'',
            circle:''
        }
    },
    createVectorSubmit() {
      // console.log(this.$store.state.search.targetType,this.$store.state.search.selectedRangeStore)
      // if (['upload','draw'].includes(this.$store.state.search.targetType)) {
      //   // 验证100km²
      //   let formdata = new FormData()
      //   let geom=JSON.stringify(this.$store.state.search.selectedRangeStore[this.$store.state.search.targetType])
      //   formdata.append("geom",geom)
      //   this.axios.post("/koa_back/geomAreaHandle",formdata).then(res => {
      //     this.bufferGeo.geojson=JSON.parse(res.data.data.geojson)
      //     this.bufferGeo.area=res.data.data.area
      //   })
      // }
      // 直接创建，不做限制，等创建项目的时候再做限制


      // 校验同名矢量
      let fd=new FormData()
      fd.append("name",this.createSearchName)
      this.axios.post("/map_service_back/vectorLibrary/checkNameValid",fd,{
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
      }).then(res => {
        if (res.data.code == 200 && res.data.message == '校验成功') {
          let formdata = new FormData()
          let geom=JSON.stringify(this.$store.state.search.selectedRangeStore[this.$store.state.search.targetType])
          formdata.append("geojson",geom)
          formdata.append("name",this.createSearchName)
          this.axios.post("/map_service_back/vectorLibrary/insertVector",formdata,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then(res => {
            if (res.data.code==200) {
              this.snackbar=true
              this.snackbarColor = '#ff9900'
              this.snackbarInfo = `创建成功！`
              this.createVectorModal = false
              this.getVectorLibrary()
            } else {
              this.snackbar=true
              this.snackbarColor = '#ff0000'
              this.snackbarInfo = `创建失败！`
              this.createVectorModal=false
            }
          })
        } else {
          this.snackbar=true
          this.snackbarColor = '#ff0000'
          this.snackbarInfo = `不可存在同名矢量，请更改名称！`
        }
      })
    },
    toggleSearchRangeSelector() {
      // if (this.showSearchRangeSelector) {//如果是开着状态
      //   this.$refs.rangeSelector.clearAll()
      // }
      this.showSearchRangeSelector=!this.showSearchRangeSelector
      if (this.showSearchRangeSelector) {//刚从关闭状态切换成开着状态
        this.$nextTick(() => {
          this.$refs.rangeSelector.clearAll()
        })
      }
    },
    createVector() {
      this.$router.push("/vectoryLibrary")
      // this.clearAll()
      // this.showSearchRangeSelector = false;
      // this.createSearchName=''
      // this.lyrdata = [
      //   {
      //     lyrType: "Tile",
      //     srcType: "XYZ",
      //     // mUrl:"https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
      //     mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=vec_w&X={x}&Y={y}&L={z}&tk=a1acdff888c05743e3603302c3f64a6d",
      //     mTitle: "路网",
      //     mName: "路网",
      //     mVisible: true
      //   },
      //   {
      //     lyrType: "Tile",
      //     srcType: "XYZ",
      //     mUrl: "https://t{0-7}.tianditu.gov.cn/DataServer?T=cva_w&x={x}&y={y}&l={z}&tk=a1acdff888c05743e3603302c3f64a6d",
      //     mTitle: "文字标注",
      //     mName: "文字标注",
      //     mVisible: true
      //   }
      // ],
      // this.vectorInfo = {}
      // this.createVectorModal = true;
      // //zoom: 4,
      // //center: L.latLng(33.978292, 105.395057),
      // setTimeout(() => {
      //   this.$refs.map.mapObject.setView(this.center,this.zoom)
      //       },500)
      
    },
    
    scrollToCurrentItem() {
        let scrolltop = this.$store.state.search.resultsStore[this.productTypeList[this.$store.state.search.currentType-1]].records.indexOf(this.$store.state.search.currentItem) * 86
        let max = document.getElementById( 'dataTable' ).scrollHeight - document.getElementById( 'dataTable' ).clientHeight - 1
        scrolltop > max ? document.getElementById( 'dataTable' ).scrollTop = max : document.getElementById( 'dataTable' ).scrollTop = scrolltop
    },
    getNowTime(){
        let dateTime = new Date();
        let year = dateTime.getFullYear();
        let month = dateTime.getMonth() + 1;
        let ri = dateTime.getDate();
        let day;
        switch (dateTime.getDay()) {
        case 0:
            day = "日";
            break;
        case 1:
            day = "一";
            break;
        case 2:
            day = "二";
            break;
        case 3:
            day = "三";
            break;
        case 4:
            day = "四";
            break;
        case 5:
            day = "五";
            break;
        case 6:
            day = "六";
            break;
        default:
            break;
        }
        let hours = dateTime.getHours();
        if(hours< 10){ hours="0" +hours }
        let minutes=dateTime.getMinutes();
        if(minutes< 10){ minutes="0" +minutes }
        let seconds=dateTime.getSeconds();
        if(seconds< 10){ seconds="0" +seconds }
        return year + "年" + month + "月" + ri + "日 星期"+ day + " " + hours + ":" +minutes + ":"+seconds;
    },
    getKey() {
      return localStorage.getItem("token");
    },
    searchVectorByName:function () {
      this.ipagination.current=1;
      this.getVectorLibrary();

    },
    getVectorLibrary:function(){
      let param=new FormData();
      if(this.searchName){
        param.append('name',this.searchName);
      }
      param.append('pageNum',this.ipagination.current);
      param.append('pageSize',this.ipagination.pageSize);
      param.append('orderType',this.tableOrderType)
      this.axios
          .post("/map_service_back/vectorLibrary/getVectorLibrary", param,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('矢量库')
        console.log(response)
        this.tableData=response.data.data;
        this.ipagination.total=response.data.total;

      })
    },
    handleTableChange:function (pagination, filters, sorter){
      console.log(pagination)
      console.log(filters)
      console.log(sorter)
      this.ipagination.current=pagination.current;
      this.ipagination.pageSize=pagination.pageSize;
      if(sorter.order=="ascend"){
        this.tableOrderType=sorter.order
      }
      else {
        this.tableOrderType=""
      }
      this.getVectorLibrary();
    },
    clickDeleteVector:function (record){
      console.log(record);
      this.deleteVectorId=record.id;
      this.deleteVectorName=record.name;
      this.deleteVectorModal=true;
    },
    clickDownloadVector: function (record) {
      this.overlay=true
      let param=new FormData();
      param.append('id',record.id)
      this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
        .then((response) => {
          record.shape = response.data.data.geojson
          let wkt=WKT.convert(JSON.parse(record.shape))
          this.axios({
              method:"post",
              url:'/accessapi/shapeService/generateShape',
              // url:'/accessapi/demandService/shapeOperation/generateShape',
              headers:{
                  'Content-type':'application/json'
              },
              data:{wkt:wkt,name:record.name}
          })
            .then(res => {
              this.overlay=false
            
              window.open('/accessapi/shapeService/generateShape/'+res.data.data)
              // window.open('/accessapi/demandService/'+res.data.data)
          })
        })
    },
    confirmDeleteVector:function () {
      let param=new FormData();
      param.append('id',this.deleteVectorId)
      this.axios
          .post("/map_service_back/vectorLibrary/deleteVector", param,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((response) => {
        console.log('删除矢量')
        console.log(response)
        if(response.data.code==200){
          this.deleteVectorModal=false;
          this.$message.success('删除成功');
          this.getVectorLibrary();
        }

      })
    },
    clickOverview: function (data) {
      this.overlay=true
     
      let param=new FormData();
      param.append('id',data.id)
      this.axios.post("/map_service_back/vectorLibrary/getVectorDetail", param)
        .then((response) => { 
          data.shape = response.data.data.geojson
          
          this.axios.post("/map_service_back/vectorLibrary/getRepositoryByVector", param,{
            headers: {
              Authorization: "Bearer " + this.getKey(),
            },
          }).then((res) => {
            data.repository = res.data.data
            if (this.lyrdata.length==2) {
              this.lyrdata.push({
                  lyrType:"lVector",
                  srcType:"Vector",
                  mUrl:data.shape,//传geom
                  mTitle:"边框",
                  mName:"边框",
                  mVisible:true
              })
            } else {
              this.lyrdata[2].mUrl=data.shape
            }
            this.vectorInfo = data
            this.overlay=false
            this.overviewVectorModal = true;
            setTimeout(() => {
              let allLayers = this.$refs.mainmap.map.getLayerGroup().getLayersArray();//直接深度获取全部图层（包括Group里面的图层）
              allLayers.forEach(layer => {
                if (layer instanceof Vector && layer.values_.title=='边框') {
                  layer.getSource().clear()
                  let geom = JSON.parse(data.shape)
                  let feature=new Feature({
                    geometry: geom.type=='MultiPolygon'?new MultiPolygon(geom.coordinates):new Polygon(geom.coordinates)
                  })
                  feature.getGeometry().transform('EPSG:4326', this.mapParams.projection)
                  layer.getSource().addFeature(feature)
                  let ext = layer.getSource().getExtent()
                  this.$refs.mainmap.map.getView().fit(ext)
                }
              })
            },500)
          })
      })
    }
  },
  mounted() {
    setInterval(() => {
        this.nowTime=this.getNowTime()
    }, 1000);
    this.getVectorLibrary();


    // // this.$refs.map.mapObject.on('click', this.pointTarget)
    // this.$refs.map.mapObject.createPane('backgroundPane')
    // this.$refs.map.mapObject.getPane('backgroundPane').style.zIndex = 0

    // L.control.mousePosition({
    //     position : 'bottomright',
    //     emptyString: '0º N0º E',
    //     lngFirst: true,
    //     //   separator: '<br>',
    //     lngFormatter: function(num) {
    //         var direction = (num < 0) ? 'W' : 'E';
    //         var formatted = Math.abs(L.Util.formatNum(num, 3)) + 'º ' + direction;
    //         return formatted;
    //     },
    //     latFormatter: function(num) {
    //         var direction = (num < 0) ? 'S' : 'N';
    //         var formatted = Math.abs(L.Util.formatNum(num, 3)) + 'º ' + direction;
    //         return formatted;
    //     }
    // }).addTo(this.$refs.map.mapObject);
    // document.getElementsByClassName("leaflet-control-mouseposition")[0].style.bottom = '24px'
    // document.getElementsByClassName("leaflet-control-mouseposition")[0].style.color = '#3F3E3E'
    // L.control.scale({position:'bottomright', imperial:false}).addTo(this.$refs.map.mapObject);
    // document.getElementsByClassName("leaflet-control-scale")[0].style.bottom = '30px'
    // document.getElementsByClassName("leaflet-control-scale-line")[0].style.background = 'rgba(255,255,255,0)'
  }
}
</script>

<style scoped lang="scss">
.overviewVectorDiv{
  width: 660px;
  height: 570px;
  // border:solid 1px #FF0000;
}
.createVectorButton{
  margin-left: 10px;
  float:left;
  width: 98px;
  height: 50px;
  border-radius: 8px;
  background: #1E81EB;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #FFFFFF;
  text-align: center;
  line-height: 50px;
  cursor:pointer;
}
.createVectorButton_grey{
  margin-left: 10px;
  float:left;
  width: 98px;
  height: 50px;
  border-radius: 8px;
  background: #F5F5F6;
  font-size: 14px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #CCCCCC;
  text-align: center;
  line-height: 50px;
}
.createVectorTitle{
  width: 1280px;
  height:40px;
  line-height: 40px;
  margin-bottom: 20px;
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
}
.createVectorDiv{
  width: 1280px;
  height: 600px;
  // border:solid 1px #9b2121;
}
.tableCtn{
  width: 100%;
  height:500px;
  padding-right: 20px;
  margin-top: 35px;
}
.searchAddCtn{
  width: 100%;
  padding-left: 180px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  margin-top: -10px;
}
.top {
  height: 84px;
  line-height: 84px;
  font-size: 20px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #3A3A3A;
}
.componentsCtn_1 {
  position:relative;
  width: 100%;
  min-height: 660px;
  height: auto;
  background: #F5F5F6;
  border-radius: 16px;
  padding-left: 35px;
}
.addVectorButton {
  width: 40px;
  height: 40px;
  border-radius: 20px;
  background: #ffffff;
  box-shadow: 2px 2px 2px #cccccc;
  float: left;
  margin-left: 15px;
  cursor:pointer;
}

</style>